
import { Question } from '../types';

export const fiqh101QuestionsExtra3: Question[] = [
  {
    id: 'fiqh111',
    text: 'What is the linguistic meaning of Taqlīd?',
    type: 'single',
    options: [
      { id: 'a', text: 'To fight against innovations', isCorrect: false },
      { id: 'b', text: 'To put a necklace around an animal\'s neck', isCorrect: true },
      { id: 'c', text: 'To study Islamic law', isCorrect: false },
      { id: 'd', text: 'To perform religious rituals', isCorrect: false }
    ],
    explanation: 'Linguistically (Lughatan), Taqlīd means putting a necklace around an animal\'s neck. In Urdu, it means to place an honorary garland over a person\'s neck.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh112',
    text: 'What is the technical definition of Taqlīd in Islamic jurisprudence?',
    type: 'single',
    options: [
      { id: 'a', text: 'Creating new religious practices', isCorrect: false },
      { id: 'b', text: 'Following someone, submitting yourself to the research of another', isCorrect: true },
      { id: 'c', text: 'Rejecting scholarly opinions', isCorrect: false },
      { id: 'd', text: 'Deriving rulings directly from the Quran and Sunnah', isCorrect: false }
    ],
    explanation: 'Technically (Iṣṭilāḥan), Taqlīd means to follow someone and submit yourself to the research of another, specifically referring to following qualified scholars of Islamic law.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh113',
    text: 'According to the course, when did Imam Abu Hanifa live?',
    type: 'single',
    options: [
      { id: 'a', text: '50-100 AH', isCorrect: false },
      { id: 'b', text: '80-150 AH', isCorrect: true },
      { id: 'c', text: '150-200 AH', isCorrect: false },
      { id: 'd', text: '200-250 AH', isCorrect: false }
    ],
    explanation: 'According to the course, Imam Abu Hanifa was born around 80 AH. This timing is important because it places him in the generation of the Tabi\'un, allowing him to meet with Anas ibn Malik, who was a companion of the Prophet ﷺ.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh114',
    text: 'What was the difference between a Nabī (Prophet) and a Rasūl (Messenger) according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'A Rasūl comes with a book or new revelation', isCorrect: true },
      { id: 'b', text: 'A Nabī does not come with a book/revelation', isCorrect: true },
      { id: 'c', text: 'There can never be two Rasūl at the same time', isCorrect: true },
      { id: 'd', text: 'There can be both a Rasūl and a Nabī at the same time', isCorrect: true },
      { id: 'e', text: 'A Nabī is higher in rank than a Rasūl', isCorrect: false }
    ],
    explanation: 'According to the course, a Rasūl comes with a book or new revelation, while a Nabī does not. There can never be two Rasūl at the same time, but there can be both a Rasūl and a Nabī simultaneously (like Musa and Harun). A Nabī\'s role was to spread, convey, and revive the meaning of existing revelation.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh115',
    text: 'What is the example given in the course about the difference between Lafdh and Ma\'nah?',
    type: 'single',
    options: [
      { id: 'a', text: 'The meaning of Salāh as prayer vs. du\'a', isCorrect: true },
      { id: 'b', text: 'The difference between Zakāt and Sadaqah', isCorrect: false },
      { id: 'c', text: 'The meaning of Sawm as fasting vs. abstinence', isCorrect: false },
      { id: 'd', text: 'The difference between Hajj and Umrah', isCorrect: false }
    ],
    explanation: 'The course provides an example about how some groups like the Isma\'ilis (including the Aga Khani community) interpret "aqīm as-salāh" differently. While the Lafdh (literal wording) is the same, they understand the Ma\'nah (meaning) as making du\'a rather than performing the ritual prayer.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh116',
    text: 'According to the course, what is the position of the \'ulamā\' on carrying out scientific research?',
    type: 'single',
    options: [
      { id: 'a', text: 'They oppose all forms of scientific research', isCorrect: false },
      { id: 'b', text: 'They are the last to adopt new scientific findings', isCorrect: true },
      { id: 'c', text: 'They only support research in Islamic sciences', isCorrect: false },
      { id: 'd', text: 'They prioritize scientific research over religious studies', isCorrect: false }
    ],
    explanation: 'According to the course, the \'ulamā\' (scholars) and muftis are usually the last people to arrive at any "party" - meaning they are cautious about adopting new findings. They care more about collecting data and information before making judgments, unlike activists and politicians who want to address things quickly.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh117',
    text: 'What principle is illustrated by the Hadith where the Prophet ﷺ approved both groups of companions who interpreted his instruction about Banu Qurayza differently?',
    type: 'single',
    options: [
      { id: 'a', text: 'That following the letter of religious instructions is most important', isCorrect: false },
      { id: 'b', text: 'That both literal and contextual understandings can be valid', isCorrect: true },
      { id: 'c', text: 'That prayer times are flexible', isCorrect: false },
      { id: 'd', text: 'That disobeying instructions is acceptable', isCorrect: false }
    ],
    explanation: 'This hadith from Sahih Bukhari (4119) illustrates the principle that both literal and contextual understandings can be valid. When the Prophet ﷺ said "Don\'t pray Asr until you reach Banu Qurayda," one group took it literally and missed Asr, while the other understood the intention and prayed on time. The Prophet ﷺ approved both approaches.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh118',
    text: 'What is the significance of "talfīq" as discussed in the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'It means creating one\'s own madhab', isCorrect: false },
      { id: 'b', text: 'It refers to selecting opinions from different madhabs for specific situations', isCorrect: true },
      { id: 'c', text: 'It means rejecting all madhabs', isCorrect: false },
      { id: 'd', text: 'It refers to combining different religious traditions', isCorrect: false }
    ],
    explanation: 'As discussed in the course, talfīq refers to the practice of selecting opinions from different madhabs for specific situations. This is not arbitrary "madhab hopping" but a principled process with specific conditions that allows for flexibility in applying Islamic law when necessary.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh119',
    text: 'What historical example of talfīq was given in the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'The Ottoman Empire\'s legal reforms', isCorrect: false },
      { id: 'b', text: 'The case of missing husbands in partition-era India', isCorrect: true },
      { id: 'c', text: 'The implementation of Islamic banking in Malaysia', isCorrect: false },
      { id: 'd', text: 'The application of hudud laws in Sudan', isCorrect: false }
    ],
    explanation: 'The course described a historical example from partition-era India, where many Muslim men went missing (likely killed) during mass migrations. The Hanafi position on missing husbands was impractical for the situation, so scholars agreed to adopt the Maliki position, which allowed wives to remarry after a certain waiting period.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh120',
    text: 'What are the two aspects of every statement as explained in the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Lafẓ (the way the word is said)', isCorrect: true },
      { id: 'b', text: 'Ma\'nah (the meaning of the word)', isCorrect: true },
      { id: 'c', text: 'Tarjīḥ (the preference for one meaning over another)', isCorrect: false },
      { id: 'd', text: 'Taṣḥīḥ (the authentication of the statement)', isCorrect: false }
    ],
    explanation: 'According to the course, every statement has two aspects: Lafẓ (the way the word is said - including spelling, pronunciation, grammar, language, etc.) and Ma\'nah (the meaning of the word - the specific manifestation of the contents).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh121',
    text: 'According to the course, what is the meaning of the maxim "al aṣlu fil ashyā\'i ibāḥatun"?',
    type: 'single',
    options: [
      { id: 'a', text: 'Everything is forbidden until proven permissible', isCorrect: false },
      { id: 'b', text: 'The default ruling in matters is permissibility', isCorrect: true },
      { id: 'c', text: 'Only ritual acts are permissible', isCorrect: false },
      { id: 'd', text: 'Necessity makes the forbidden permissible', isCorrect: false }
    ],
    explanation: 'The maxim "al aṣlu fil ashyā\'i ibāḥatun" means "the default ruling in matters/things is permissibility." This is an important principle in Islamic jurisprudence that states things are generally permitted unless specifically prohibited.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh122',
    text: 'According to the course, what Arabic term refers to categories of impurity that can be physical or a state?',
    type: 'single',
    options: [
      { id: 'a', text: 'Ṭahāra', isCorrect: false },
      { id: 'b', text: 'Najāsah', isCorrect: true },
      { id: 'c', text: 'Ḥadath', isCorrect: false },
      { id: 'd', text: 'Janābah', isCorrect: false }
    ],
    explanation: 'Najāsah (نَجَاسَةٌ) refers to impurity in Islam, which has two main categories: Ḥaqīqīyatun (physical/tangible impurity) and Ḥukmīyyatun (intangible impurity or a state of ritual impurity).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh123',
    text: 'According to the course, which of the following breaks wuḍū\'?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Passing gas', isCorrect: true },
      { id: 'b', text: 'Touching najāsah (impurity)', isCorrect: false },
      { id: 'c', text: 'Vomiting', isCorrect: true },
      { id: 'd', text: 'Nocturnal emissions', isCorrect: false }
    ],
    explanation: 'According to the course, passing gas and vomiting break wuḍū\' as they are examples of impurity exiting the body. Touching najāsah (impurity) does not break wuḍū\'; only the exit of impurity from one\'s body breaks wuḍū\'. Nocturnal emissions require ghusl, not just wuḍū\'.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh124',
    text: 'What is the difference between ghalīẓah and khafīfah types of najāsah as discussed in the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Ghalīẓah is from halal animals, khafīfah is from haram animals', isCorrect: false },
      { id: 'b', text: 'Ghalīẓah is heavy/severe impurity, khafīfah is light impurity', isCorrect: true },
      { id: 'c', text: 'Ghalīẓah requires ghusl, khafīfah requires wuḍū\'', isCorrect: false },
      { id: 'd', text: 'Ghalīẓah is visible, khafīfah is invisible', isCorrect: false }
    ],
    explanation: 'According to the course, ghalīẓah (غَلِيظَةٌ) refers to heavy/severe impurity (the default for physical impurities), while khafīfah (خَفِيفَةٌ) refers to light impurity. Khafīfah applies to substances like the urine of animals whose meat is halal to eat.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh125',
    text: 'According to the course, what is the view of Imām Mālik regarding enforcing uniformity in Islamic practice?',
    type: 'single',
    options: [
      { id: 'a', text: 'He advocated for strict uniformity across the Muslim world', isCorrect: false },
      { id: 'b', text: 'He rejected the Abbasid caliph\'s attempt to make his Muwaṭṭa\' the standard reference', isCorrect: true },
      { id: 'c', text: 'He believed all regions should follow the practice of Madinah only', isCorrect: false },
      { id: 'd', text: 'He advocated for consolidating all madhabs into one', isCorrect: false }
    ],
    explanation: 'According to the course, when Harūn al-Rashīd (the Abbasid caliph) suggested hanging Imām Mālik\'s Muwaṭṭa\' on the Ka\'bah and making everyone follow the Māliki madhab, Imām Mālik rejected this idea, saying: "Indeed the companions of the Prophet of Allāh had differences of opinion, so who am I to take people away from the opinions of the ṣaḥābah."',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh126',
    text: 'What does the course identify as the primary difference between ikhtilāf and khilāf?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Ikhtilāf has dalīl (evidence) to support it, khilāf does not', isCorrect: true },
      { id: 'b', text: 'Ikhtilāf brings mercy, khilāf brings bid\'ah (innovation)', isCorrect: true },
      { id: 'c', text: 'Ikhtilāf is praised, khilāf is blamed', isCorrect: true },
      { id: 'd', text: 'Ikhtilāf is modern, khilāf is traditional', isCorrect: false }
    ],
    explanation: 'According to the course, the key differences between ikhtilāf and khilāf are: ikhtilāf has dalīl (evidence) to support it while khilāf does not; ikhtilāf brings mercy while khilāf brings bid\'ah (innovation); and ikhtilāf is generally praiseworthy while khilāf is blameworthy.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh127',
    text: 'According to the course, what is the meaning of "mujtahad fīhi" in the context of ikhtilāf?',
    type: 'single',
    options: [
      { id: 'a', text: 'A scholar qualified to perform ijtihād', isCorrect: false },
      { id: 'b', text: 'An issue where scholars cannot have differences of opinion', isCorrect: false },
      { id: 'c', text: 'An issue where scholars can legitimately have differences of opinion', isCorrect: true },
      { id: 'd', text: 'The process of performing ijtihād', isCorrect: false }
    ],
    explanation: 'According to the course, "mujtahad fīhi" (or "mukhtalaf fīhi") refers to issues where scholars can legitimately have differences of opinion. This contrasts with "mujma\' \'alayh," which refers to issues where there is scholarly consensus and differences are not permitted.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh128',
    text: 'According to the course, who is qualified to engage in ikhtilāf (legitimate scholarly disagreement)?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Anyone with basic knowledge of Islam', isCorrect: false },
      { id: 'b', text: 'Those with knowledge-based qualification (\'ilmī ahlīyyah)', isCorrect: true },
      { id: 'c', text: 'Those with faith-based qualification (ta\'ahhulu diyānatan)', isCorrect: true },
      { id: 'd', text: 'Those who have memorized many hadith', isCorrect: false }
    ],
    explanation: 'According to the course, qualification to engage in ikhtilāf requires both knowledge-based qualification (\'ilmī ahlīyyah) - deep understanding of Islamic sciences - and faith-based qualification (ta\'ahhulu diyānatan) - personal piety and practice. Merely memorizing texts or having basic knowledge is insufficient.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh129',
    text: 'What was the attitude of early scholars toward issuing fatwas according to the example of Imām Mālik cited in the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'They issued fatwas freely based on their understanding', isCorrect: false },
      { id: 'b', text: 'They required permission from political authorities', isCorrect: false },
      { id: 'c', text: 'They sought validation from other scholars before issuing fatwas', isCorrect: true },
      { id: 'd', text: 'They only issued fatwas on topics explicitly mentioned in texts', isCorrect: false }
    ],
    explanation: 'According to the course, Imām Mālik said, "I did not give fatwa until 70 scholars of Madīnah said I could." This illustrates the cautious, humble approach early scholars took toward issuing fatwas, seeking validation from their peers before presuming to guide others.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh130',
    text: 'According to the course, what is the relationship between sharī\'ah and fiqh?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Sharī\'ah is fixed and unchangeable, fiqh changes with circumstances', isCorrect: true },
      { id: 'b', text: 'Sharī\'ah contains general principles, fiqh applies them to specific situations', isCorrect: true },
      { id: 'c', text: 'Sharī\'ah comes directly from the Qur\'ān and Sunnah, fiqh is deduced from sharī\'ah', isCorrect: true },
      { id: 'd', text: 'Sharī\'ah and fiqh are different terms for the same concept', isCorrect: false }
    ],
    explanation: 'According to the course, sharī\'ah refers to the fixed, unchangeable divine law found in the Qur\'ān and Sunnah, while fiqh is the human understanding and application of that law, which can change with circumstances. Sharī\'ah provides general principles, and fiqh shows how to apply them in specific situations.',
    topic: 'fiqh101'
  }
];
